import React from 'react';
import './BillData.scss';
import {useTranslation} from "react-i18next";

const BillData = ({invoiceInfo}) => {
  const {t} = useTranslation();

  return (
  <div className="BillData" data-testid="BillData" >
    <h2 className={'title headline-bold-fs4'}>
      {t('casses.amministratori_di_condominio.bollette.title')}
    </h2>
    <div className="data-container">
      <div className={'value-container'}>
        <div className={'data-label paragraph-small-fs9'}>{t("casses.amministratori_di_condominio.bollette.importo.label")}</div>
        <div className={'data-value paragraph-large-fs7'}>{invoiceInfo?.amount ? invoiceInfo.amount + " €" : '-'}</div>
      </div>
      <div className={'value-container'}>
        <div className={'data-label paragraph-small-fs9'}>{t("casses.amministratori_di_condominio.bollette.tipologia.label")}</div>
        <div className={'data-value paragraph-large-fs7'}>{invoiceInfo?.invoiceType ? invoiceInfo.invoiceType : "-" }</div>
      </div>
      <div className={'value-container'}>
        <div className={'data-label paragraph-small-fs9'}>{t("casses.amministratori_di_condominio.bollette.fatturazioni.label")}</div>
        <div className={'data-value paragraph-large-fs7'}>{invoiceInfo?.consumption ? invoiceInfo.consumption : '-'}</div>
      </div>
    </div>
  </div>
  )}

BillData.propTypes = {};

export default BillData;
